import classNames from 'classnames';
import { Component } from 'react';
import { Field } from 'redux-form';
import styles from './FormField.module.css';
import { renderField } from './Input';

export class FormField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    componentDidMount() {
        const { value } = this.props;

        this.setState({ value: value });
    }

    handleChange(e) {
        const { onChangeHandler } = this.props;
        const value = e.target.value;

        this.setState({ value: value });

        if (onChangeHandler) {
            onChangeHandler(value);
        }
    }

    render() {
        const fieldClassNames = classNames(
            styles.formField,
            this.props.className
        );

        return (
            <div className={fieldClassNames}>
                <Field
                    onChange={(e) => {
                        this.handleChange(e);
                    }}
                    component={renderField}
                    {...this.props}
                />
                {this.props.children}
            </div>
        );
    }
}
